import { Box, Chip, Stack } from '@mui/material'
import { TBalanceCurrency } from '../../core/types/Tenant'

interface CurrencyToggleProps {
  value: TBalanceCurrency
  onChange: (value: TBalanceCurrency) => void
}

const CircleFlag = ({ children }: { children: React.ReactNode }) => (
  <Box
    sx={{
      width: 18,
      height: 18,
      borderRadius: '50%',
      overflow: 'hidden',
      display: 'inline-flex',
      flexShrink: 0,
    }}
  >
    {children}
  </Box>
)

const BrazilFlagIcon = () => (
  <CircleFlag>
    <svg width="18" height="18" viewBox="0 0 20 20">
      <rect width="20" height="20" fill="#009C3B" />
      <polygon points="10,2 18,10 10,18 2,10" fill="#FEDD00" />
      <circle cx="10" cy="10" r="4.2" fill="#002776" />
    </svg>
  </CircleFlag>
)

const UsaFlagIcon = () => {
  const stripeHeight = 20 / 7
  return (
    <CircleFlag>
      <svg width="18" height="18" viewBox="0 0 20 20">
        <rect width="20" height="20" fill="#fff" />
        {[0, 2, 4, 6].map((i) => (
          <rect
            key={i}
            x="0"
            y={i * stripeHeight}
            width="20"
            height={stripeHeight}
            fill="#B22234"
          />
        ))}
        <rect x="0" y="0" width="9" height={stripeHeight * 4} fill="#3C3B6E" />
      </svg>
    </CircleFlag>
  )
}

const CHIPS: {
  value: TBalanceCurrency
  label: string
  icon: React.ReactElement
}[] = [
  { value: 'brl', label: 'R$', icon: <BrazilFlagIcon /> },
  { value: 'usd', label: 'US$', icon: <UsaFlagIcon /> },
]

export const CurrencyToggle = ({ value, onChange }: CurrencyToggleProps) => {
  return (
    <Stack direction="row" spacing={1}>
      {CHIPS.map((chip) => (
        <Chip
          key={chip.value}
          icon={chip.icon}
          label={chip.label}
          onClick={() => onChange(chip.value)}
          color={value === chip.value ? 'primary' : 'default'}
          variant={value === chip.value ? 'filled' : 'outlined'}
          sx={{ fontWeight: 600, fontSize: '14px', px: 1 }}
        />
      ))}
    </Stack>
  )
}
